class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  // 서버 응답을 기다리지 않고 장바구니 아이콘 숫자를 즉시 올린다(낙관적 업데이트).
  // cart-icon-bubble 자체는 가볍지만, 무거운 mini-cart 섹션과 같은 요청에 묶여 렌더되므로
  // 숫자 반영이 늦게 느껴진다. 클릭 즉시 숫자를 갱신하고, renderContents()가 도착하면
  // 정확한 값으로 덮어쓴다. 실패 시에는 반환된 롤백 함수로 원래 값으로 되돌린다.
  // Optimistically bump the cart count bubble immediately, instead of waiting for the
  // (heavy mini-cart) server render that shares the same request. renderContents() later
  // overwrites it with the authoritative markup; on failure call the returned rollback fn.
  bumpCount(quantity) {
    const qty = parseInt(quantity, 10);
    const snapshots = ['cart-icon-bubble', 'mobile-cart-icon-bubble']
      .map((id) => document.getElementById(id))
      .filter((el) => el)
      .map((el) => ({ el, html: el.innerHTML }));

    // 롤백 함수: 각 버블의 원래 innerHTML 복원 / rollback: restore each bubble's original HTML
    const rollback = () => snapshots.forEach(({ el, html }) => { el.innerHTML = html; });

    if (!qty || qty < 1) return rollback;

    snapshots.forEach(({ el }) => {
      const bubble = el.querySelector('.cart-count-bubble');
      if (bubble) {
        const numberEl = bubble.querySelector('[aria-hidden="true"]');
        const current = numberEl ? parseInt(numberEl.textContent, 10) || 0 : 0;
        const next = current + qty;
        if (next < 100 && numberEl) {
          // 일반적인 경우: 숫자만 갱신해 접근성 텍스트는 보존 / common path: update number only
          numberEl.textContent = next;
        } else {
          // 100개 이상이면 점 표시로 전환 / 100+ items: switch to dot indicator
          bubble.classList.add('cart-count-bubble--dot');
          if (numberEl) numberEl.remove();
        }
      } else {
        // 빈 장바구니였던 경우 버블을 새로 생성 / cart was empty: create the bubble
        const newBubble = document.createElement('span');
        newBubble.className = qty >= 100 ? 'cart-count-bubble cart-count-bubble--dot' : 'cart-count-bubble';
        if (qty < 100) newBubble.innerHTML = `<span aria-hidden="true">${qty}</span>`;
        el.appendChild(newBubble);
      }
    });

    return rollback;
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
